var render = function render(){
  var _vm$banner;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.banner && (_vm.pc && _vm.detect == 'pc' || _vm.mobile && _vm.detect == 'mobile') ? _c('v-sheet', {
    class: `main-banner main-banner-${_vm.random}`
  }, [_c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_vm._l(((_vm$banner = _vm.banner) === null || _vm$banner === void 0 ? void 0 : _vm$banner.slides) || [], function (slide, index) {
    return [_c('div', {
      key: index,
      staticClass: "swiper-slide"
    }, [_c('v-card', {
      attrs: {
        "to": slide !== null && slide !== void 0 && slide.isOuterLink ? undefined : slide === null || slide === void 0 ? void 0 : slide.url,
        "href": slide !== null && slide !== void 0 && slide.isOuterLink ? slide === null || slide === void 0 ? void 0 : slide.url : undefined,
        "target": slide === null || slide === void 0 ? void 0 : slide.target,
        "flat": "",
        "tile": ""
      }
    }, [_vm.vertical ? _c('v-responsive', {
      attrs: {
        "aspect-ratio": 190 / 526,
        "max-width": "190"
      }
    }, [_c('img', {
      attrs: {
        "src": slide === null || slide === void 0 ? void 0 : slide.image,
        "width": "190"
      }
    })]) : _c('v-responsive', {
      attrs: {
        "aspect-ratio": 1380 / 126
      }
    }, [_c('img', {
      staticClass: "w-100 mx-auto",
      attrs: {
        "src": slide === null || slide === void 0 ? void 0 : slide.image,
        "max-width": "1380"
      }
    })])], 1)], 1)];
  })], 2)])]) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }